import { render, staticRenderFns } from "./VolunteerDetailCpt.vue?vue&type=template&id=673a9278&scoped=true&"
import script from "./VolunteerDetailCpt.vue?vue&type=script&lang=ts&"
export * from "./VolunteerDetailCpt.vue?vue&type=script&lang=ts&"
import style0 from "./VolunteerDetailCpt.vue?vue&type=style&index=0&id=673a9278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673a9278",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VContainer,VRow})
